document.addEventListener('DOMContentLoaded', initFormData);

const callBoxShopName = document.currentScript?.getAttribute('data-shop-name') || '';

function initFormData() {
	const form = document.getElementById('boa-contact-form');
	if (!form) {
		return;
	}

	const formButton = document.querySelector('.contact-form__button');
	if (!formButton) {
		return;
	}

	const requiredFields = form.querySelectorAll('[required]');
	

	formButton.addEventListener('click', (event) => {
		event.preventDefault();

		const formDataObject = Object.fromEntries(new FormData(form).entries());
		const error = handleFormValidations(requiredFields);
		if (error) {
			// Show error message through handleFormValidations
			return;
		}
		// Set loading state
		setButtonLoading(formButton, true);
		sendFormData(formDataObject, formButton);
	});
}

// Function to generate a unique event ID
function generateEventId() {
	return Date.now() * 100000 + Math.floor(Math.random() * 100000);
}

async function sendFormData(formData, formButton) {

	try {
		await sendFormDataToServer(formData);
		handleSuccess(formButton);
	} catch (error) {
		handleErrorMessage(error, formButton);
	}
}

async function sendFormDataToServer(formData) {
	// Retrieve the latest UTM parameters
	const storedUtmParams = JSON.parse(sessionStorage.getItem('utmParams')) || {};

	// Build the final JSON structure
	const requestBody = {
		sourceSender: 'BOA',
		eventType: 'New Lead',
		eventId: generateEventId(),
		properties: {
			firstName: formData.first_name,
			lastName: formData.last_name,
			email: formData.email,
			phone: formData.phone,
			leadSource: 'שופיפיי',
			leadType: 'פרטי',
			interestedIn: formData.interestedIn,
			description: formData.description || '',
			customerApprovedMailing: formData.customerApprovedMailing === 'on', // Convert checkbox value to boolean
			...storedUtmParams, // Use stored UTM if available, otherwise URL parameters
			refPage: document.referrer || '', // Capture referrer URL
		},
		// Callbox data
		callboxData: {
			phone: formData.phone,
			fullname: formData.first_name + ' ' + formData.last_name,
			email: formData.email,
			approval: formData.customerApprovedMailing === 'on',
			'free_text': formData.description,
			'form_name': 'טופס צור קשר - ' + callBoxShopName,
			'landing_url': window.location.href,
			sid: formData.sid,
			'store_name': callBoxShopName
		}
	};


	const response = await fetch('/apps/proxy/api/zoho/form', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(requestBody),
	});

	if (!response.ok) {
		const errorMessage = await response.json();
		throw new Error(errorMessage.message);
	}

	return response.json();
}


function setButtonLoading(button, isLoading) {
	const spinner = button.querySelector('.button-spinner');
	if (!spinner) {
		return;
	}
	
	if (isLoading) {
		button.disabled = true;
		button.classList.add('loading');
		spinner.style.display = 'flex';
	} else {
		button.disabled = false;
		button.classList.remove('loading');
		spinner.style.display = 'none';
	}
}

function handleSuccess(formButton) {
	const successBanner = document.getElementById('boa-banner-success');
	const errorBanner = document.getElementById('boa-banner-error');
	const formWrapper = document.querySelector('.contact-form__wrapper');
	errorBanner.classList.add('hide-message');
	successBanner.classList.remove('hide-message');
	formWrapper.classList.add('hide-message');
	setButtonLoading(formButton, false);
}

function handleErrorMessage(error, formButton) {
	const errorBanner = document.getElementById('boa-banner-error');
	const formWrapper = document.querySelector('.contact-form__wrapper');
	errorBanner.textContent = error;
	errorBanner.classList.remove('hide-message');
	formWrapper.classList.remove('hide-message');
	setButtonLoading(formButton, false);
}

function handleFormValidations(requiredFields) {

	for (const field of requiredFields) {
		const isValid = field.checkValidity();
		if (!isValid) {
			field.reportValidity();
			return true;
		}
	}

	return null;
}